<template>
  <div :key="$route.params.objectid">
    <cbs-object
      v-if="objectFull"
      :objectid="objectid"
      :object-full="objectFull"
    />
  </div>
</template>

<script>
import CbsObject from '@/cubus/components/object/CbsObject.vue'
import useCubus from '@/cubus/services/useCubus'

export default {
  components: {
    CbsObject,
  },
  props: {},
  data() {
    return {
      objectid: Number(this.$route.params.objectid),
      objectFull: null,
    }
  },
  created() {
    useCubus.setPageTitle(`Object ${this.objectid}`)
    this.init()
  },
  methods: {
    init() {
      this.initObject()
    },
    async initObject() {
      this.objectFull = await useCubus.loadObject(this, { objectid: this.objectid })
      if (this.objectFull && this.objectFull.object && this.objectFull.object.name) {
        useCubus.setPageTitle(this.objectFull.object.name)
      }
    },
    /*
    onObjectLoad(obj) {
      // console.log('onObjectLoad', obj)
      this.objectFull = obj
      if (obj && obj.object && obj.object.name) {
        useCubus.setPageTitle(obj.object.name)
      }
    },
    */
  },
  beforeRouteUpdate(to, from, next) {
    // Обновляем данные при изменении параметра маршрута
    this.objectFull = null
    this.objectid = to.params.objectid
    this.init()
    // this.fetchUserData(this.userId);
    next() // Продолжить навигацию
  },
}
</script>

<style scoped>

</style>
